export default __webpack_public_path__ + "static/media/ODEImg6.d7be564f.PNG";